<template>
  <div class="activate-page">
    <div v-if="!message" class="activate-loader-wrapper">
      <Loader />
    </div>

    <div v-else>
      <a data-v-41030e19="" href="/" class="logo router-link-active">
        <img data-v-41030e19="" src="/img/logo_en_sm.0ab571c9.svg" alt="Indigo Logo">
      </a>

      <p class="activate-message" :class="{ 'text-success': isSuccessStyle, 'text-danger': !isSuccessStyle }">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>

import Loader from '@/components/Loader.vue'

export default {
  name: 'activate',

  components: {
    Loader
  },

  data() {
    return {
      message: null
    }
  },

  computed: {
    isSuccessStyle() {
      return this.message.includes('verified')
    }
  },

  created() {
    this.axios({
      method: 'get',
      url: `users/user/activate/${this.$route.params.param1}/${this.$route.params.param2}/`
    }).then(result => {
      this.message = "Email has already been verified."
    }
    ).catch(error => {
      this.message = error.response.data.message
    })
  }
}

</script>

<style lang="scss">
.activate-page {
  background: #fff url(/img/back-white.eab8b7a8.png) center 0 no-repeat;
  min-height: 100vh;
  position: relative;

  padding-top: 70px;
}

.activate-loader-wrapper {
  margin-top: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activate-loader-wrapper svg {
  display: block;
  margin: auto;
  width: 100px;
  height: 100px;
}

.activate-message {
  max-width: 400px;
  margin: 60px auto 32px;

  font-size: 26px;

  text-align: center;
}
</style>